/* eslint-disable no-await-in-loop */
/* eslint-disable no-underscore-dangle */
import React, { useEffect, useRef } from 'react';
import { inject, observer } from 'mobx-react';
import classnames from 'classnames';
import UserModel from '@/models/user';
import { Swiper as SwiperClass } from 'swiper/core';
import 'swiper/swiper.less';
import s from './index.less';
import BoxOrder from '../../BoxOrder';
import { Icon } from '@/components';
import { useSize } from 'ahooks';
import { Swiper, SwiperSlide } from 'swiper/react';

interface SecondColumnLayoutProps {
  user?: UserModel;
  list?: any;
  limit?: number;
}

const SecondColumnLayout: React.FC<SecondColumnLayoutProps> = inject(({ store }) => {
  return {
    user: store.user,
  };
})(
  observer((props: SecondColumnLayoutProps) => {
    const { list, limit = 9 } = props;
    const [currentPage, setCurrentPage] = React.useState<number>(1);
    const pageControllerRef = useRef<any>();
    const pageControllerSize = useSize(pageControllerRef);
    const swiperRef = React.useRef<SwiperClass>();
    const pageSize = React.useMemo(() => {
      return Math.ceil(list.length / limit);
    }, [list, limit]);

    const onSwiper = React.useCallback((swiper: any) => {
      swiperRef.current = swiper;
    }, []);
    // 切换分页
    const nextPage = React.useCallback(async () => {
      if (currentPage !== pageSize && swiperRef.current) {
        swiperRef.current.slideNext();
        setCurrentPage(currentPage + 1);
      }
    }, [currentPage, pageSize, swiperRef]);

    const prevPage = React.useCallback(async () => {
      if (currentPage !== 1 && swiperRef.current) {
        swiperRef.current.slidePrev();
        setCurrentPage(currentPage - 1);
      }
    }, [currentPage, swiperRef]);

    const keyboardSlide = React.useCallback(async (pageIndex: number) => {
      setCurrentPage(pageIndex + 1);
    }, []);

    return (
      <div className={s.container} ref={pageControllerRef}>
        <Swiper
          spaceBetween={1000}
          allowTouchMove={false}
          speed={0}
          style={{ height: '100%', width: '100%' }}
          onSwiper={onSwiper}
          onSlideChange={({ realIndex }) => keyboardSlide(realIndex)}
          width={pageControllerSize?.width}
        >
          {new Array(pageSize).fill(1).map((num, index) => {
            const members = (list && list.slice(index * limit, limit * (index + 1))).map(
              (item: any) => item.yxUid.toString()
            );

            return (
              <SwiperSlide
                key={index + num}
                virtualIndex={index}
                style={{ width: 'auto', height: 'auto' }}
              >
                <BoxOrder members={members}></BoxOrder>
              </SwiperSlide>
            );
          })}
        </Swiper>

        {pageSize > 1 && (
          <div className={s.pagination}>
            <div
              className={classnames(s.left, { [s.disabled]: currentPage === 1 })}
              onClick={prevPage}
            >
              <Icon
                name="icon-a-continuerecording"
                className={s.leftIcon}
                size={12}
                mode="symbol"
              />
            </div>
            <div
              className={classnames(s.right, {
                [s.disabled]: currentPage === pageSize,
              })}
              onClick={nextPage}
            >
              <Icon
                name="icon-a-continuerecording"
                className={s.nextPage}
                size={12}
                mode="symbol"
              />
            </div>
          </div>
        )}
      </div>
    );
  })
);
export default SecondColumnLayout;
